var _style, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEthIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2500 2500",
    style: {
      enableBackground: "new 0 0 2500 2500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#2B86F8;}\n\t.st1{fill:#FFFFFF;fill-opacity:0.602;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#FFFFFF;fill-opacity:0.2;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 1250,
    cy: 1250,
    r: 1250
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1288.9,312.5v693l585.7,261.7L1288.9,312.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1288.9,312.5l-585.8,954.7l585.8-261.7L1288.9,312.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1288.9,1716.2v470.9l586.1-810.9L1288.9,1716.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1288.9,2187.1v-470.9l-585.8-339.9L1288.9,2187.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1288.9,1607.3l585.7-340.1l-585.7-261.6V1607.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M703.1,1267.2l585.8,340.1v-601.6L703.1,1267.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthIcon);
export default __webpack_public_path__ + "static/media/eth_icon.23f2f1e3cdfdfe2e4151bf3eba487706.svg";
export { ForwardRef as ReactComponent };